<template>
  <v-template>
    <v-main>
      <v-app-bar fixed dark app>
        <a href="/" style="height: 100%">
          <img :src="require('@/assets/logo2.png')" style="height: 100%" />
        </a>
        <v-spacer class="d-flex d-md-none"></v-spacer>
        <a
          class="gplay-wrap"
          href="https://play.google.com/store/apps/details?id=com.stonks.app&amp;pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
          target="_blank"
          title="Get it on Google Play"
        >
          <img :src="require('@/assets/gplay.png')" alt="Google Play Download Logo" />
        </a>
        <v-spacer></v-spacer>
        <v-icon @click="darkMode" title="Dark Mode">mdi-theme-light-dark</v-icon>
      </v-app-bar>

      <v-container fluid pt-0>
        <v-container :fluid="$vuetify.breakpoint.lgAndDown" pt-0>
          <v-row justify="center" class="intro-bg" no-gutters style="z-index: 3 !important">
            <v-col cols="12" sm="6">
              <h3>Welcome to StonksPro Apps!</h3>
              <h1>Privacy Policy</h1>
              <p>Stonks Pro Apps built the StonksPro app as a Freemium app. This SERVICE is provided by Stonks Pro Apps at no cost and is intended for use as is.</p>
              <p>
                This page is used to inform visitors regarding my policies with the collection, use, and disclosure of Personal Information if anyone decided to use my Service.
              </p>
              <p>
                If you choose to use my Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that I collect is used
                for providing and improving the Service. I will not use or share your information with anyone except as described in this Privacy Policy.
              </p>
              <p>
                The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at StonksPro unless otherwise defined in this
                Privacy Policy.
              </p>
            </v-col>
          </v-row>
          <v-row justify="center" class="intro-bg" no-gutters style="z-index: 3 !important">
            <v-col cols="12" sm="6">
              <div class="d-flex flex-row-reverse">
                <v-btn class="ma-2" outlined @click="closeAll"> Close all </v-btn>
                <v-btn class="ma-2" outlined @click="openAll"> Open all </v-btn>
              </div>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col cols="12" sm="6">
              <v-expansion-panels accordion multiple tile flat v-model="panel">
                <v-expansion-panel>
                  <v-divider></v-divider>
                  <v-expansion-panel-header><strong>Information Collection and Use</strong></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <p>
                      For a better experience, while using our Service, I may require you to provide us with certain personally identifiable information, including but not limited
                      to Email,Username. The information that I request will be retained on your device and is not collected by me in any way.
                    </p>
                    <div>
                      <p>The app does use third party services that may collect information used to identify you.</p>
                      <p>Link to privacy policy of third party service providers used by the app</p>
                      <ul>
                        <li><a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer">Google Play Services</a></li>
                        <li><a href="https://support.google.com/admob/answer/6128543?hl=en" target="_blank" rel="noopener noreferrer">AdMob</a></li>
                        <li><a href="https://firebase.google.com/policies/analytics" target="_blank" rel="noopener noreferrer">Google Analytics for Firebase</a></li>
                        <li><a href="https://firebase.google.com/support/privacy/" target="_blank" rel="noopener noreferrer">Firebase Crashlytics</a></li>
                      </ul>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-divider></v-divider>
                  <v-expansion-panel-header><strong>Log Data</strong></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <p>
                      I want to inform you that whenever you use my Service, in a case of an error in the app I collect data and information (through third party products) on your
                      phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the
                      configuration of the app when utilizing my Service, the time and date of your use of the Service, and other statistics.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-divider></v-divider>
                  <v-expansion-panel-header><strong>Cookies</strong></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <p>
                      Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that
                      you visit and are stored on your device's internal memory.
                    </p>
                    <p>
                      This Service does not use these “cookies” explicitly. However, the app may use third party code and libraries that use “cookies” to collect information and
                      improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to
                      refuse our cookies, you may not be able to use some portions of this Service.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-divider></v-divider>
                  <v-expansion-panel-header><strong>Service Providers</strong></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <p>I may employ third-party companies and individuals due to the following reasons:</p>
                    <ul>
                      <li>To facilitate our Service;</li>
                      <li>To provide the Service on our behalf;</li>
                      <li>To perform Service-related services; or</li>
                      <li>To assist us in analyzing how our Service is used.</li>
                    </ul>
                    <p>
                      I want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them
                      on our behalf. However, they are obligated not to disclose or use the information for any other purpose.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-divider></v-divider>
                  <v-expansion-panel-header><strong>Security</strong></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <p>
                      I value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no
                      method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and I cannot guarantee its absolute security.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-divider></v-divider>
                  <v-expansion-panel-header><strong>Links to Other Sites</strong></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <p>
                      This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not
                      operated by me. Therefore, I strongly advise you to review the Privacy Policy of these websites. I have no control over and assume no responsibility for the
                      content, privacy policies, or practices of any third-party sites or services.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-divider></v-divider>
                  <v-expansion-panel-header><strong>Children’s Privacy</strong></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <p>
                      These Services do not address anyone under the age of 13. I do not knowingly collect personally identifiable information from children under 13 years of age.
                      In the case I discover that a child under 13 has provided me with personal information, I immediately delete this from our servers. If you are a parent or
                      guardian and you are aware that your child has provided us with personal information, please contact me so that I will be able to do necessary actions.
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-divider></v-divider>
                  <v-expansion-panel-header><strong>Changes to This Privacy Policy</strong></v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <p>
                      I may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. I will notify you of any changes by
                      posting the new Privacy Policy on this page.
                    </p>
                    <p>This policy is effective as of 2021-07-05</p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-container>
      </v-container>
    </v-main>
  </v-template>
</template>

<script>
export default {
  name: "StonksPro",
  metaInfo: {
    title: "StonksPro - Privacy Policy",
    htmlAttrs: {
      lang: "en",
    },
    meta: [
      { charset: "utf-8" },
      { name: "description", content: "StonksPro | Blast through Memes TO THE MOON!" },

      { property: "og:title", content: "StonksPro - Privacy Policy" },
      { property: "og:description", content: "StonksPro | Blast through Memes TO THE MOON!" },
      { property: "og:image", content: "https://stonks.app/stonksPics/banner01.png" },
      { property: "og:url", content: "https://stonks.app/" },

      { property: "fb:app_id", content: "1575230175940823" },

      { property: "twitter:title", content: "StonksPro" },
      { property: "twitter:description", content: "StonksPro | Blast through Memes TO THE MOON!" },
      { property: "twitter:image", content: "https://stonks.app/stonksPics/banner01.png" },
      { property: "twitter:card", content: "summary_large_image" },
      { property: "twitter:site", content: "@Stonks_app" },
    ],
  },

  data: () => ({
    items: 8,
    panel: [],
  }),
  created() {
    this.openAll();
    this.$nextTick(() => {
      this.closeAll();
    });
    const darkMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    if (darkMediaQuery.matches) {
      setTimeout(() => {
        this.$vuetify.theme.dark = true;
      }, 0);
    }
    darkMediaQuery.addEventListener("change", (e) => {
      try {
        this.$vuetify.theme.dark = e.target.matches;
      } catch (err) {}
    });
  },

  methods: {
    darkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },

    openAll() {
      this.panel = [...Array(this.items).keys()].map((k, i) => i);
    },
    closeAll() {
      this.panel = [];
    },
  },
};
</script>

<style scoped>
.logo-wrap,
.play-wrap {
  height: 86px;
  box-sizing: border-box;
  padding: 3px;
  border-radius: 10px;
}

.logo-wrap img {
  background-color: #000;
  height: 80px;
  border-radius: 10px;
}

.gplay-wrap {
  height: 100%;
  box-sizing: border-box;
  padding: 3px 5px;
}
.gplay-wrap img {
  height: 100%;
}

@media screen and (max-width: 960px) {
  .logo-wrap,
  .play-wrap {
    height: 100%;
    box-sizing: border-box;
    padding: 3px;
    border-radius: 10px;
  }
  .logo-wrap img {
    height: 100%;
  }
  .play-wrap img {
    height: 100%;
  }
}
</style>
